import React, { Component } from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../../utils/scale-size';
import { FocusableParent, Focusable } from '../navigation';
import ListTick from '../Icons/tick-list';

const StyledList = styled(FocusableParent)`
  min-width: ${scaleSize(400)}px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ListItem = styled(Focusable)`
  min-width: ${scaleSize(400)}px;
  height: ${scaleSize(80)}px;
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(80)}px;
  padding-left: ${scaleSize(40)}px;
  margin-bottom: ${scaleSize(15)}px;
  color: ${({ theme, selected }) => (selected ? theme.activeColor : theme.mainTextColor)};
  box-sizing: border-box;
  border-radius: ${scaleSize(12)}px;
  display: block;
  position: relative;

  & svg {
    display: ${({ selected }) => (selected ? 'inline-block' : 'none')};
    padding-left: ${scaleSize(20)}px;
  }

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
    color: ${({ theme }) => theme.activeColorText};

    svg > path {
      stroke: ${({ theme }) => theme.activeColorText};
    }
  }
`;

class List extends Component {
  onEnter = selectedItem => {
    const { closeAndReturnFocus, onSelect } = this.props;

    onSelect(selectedItem);

    closeAndReturnFocus();
  };
  render() {
    const { items, selectedItem, sectionName } = this.props;

    return (
      <StyledList
        defaultSection
        sectionName={sectionName}
        config={{
          leaveFor: {
            up: '@OVERLAY_BACK_BUTTON',
            down: '',
            left: '@OVERLAY_BACK_BUTTON',
            right: '',
          },
        }}
      >
        {items.map(item => (
          <ListItem
            key={`overlay-list-${item.id}`}
            onEnter={() => this.onEnter(item.id)}
            focusOnMouseEnter
            selected={selectedItem === item.id}
          >
            {item.title}
            <ListTick />
          </ListItem>
        ))}
      </StyledList>
    );
  }
}

export default List;
